import * as cpd from './cpd';
import * as partWatching from './partWatching';
import * as sales from './sales';

const reducers = {
  ...cpd,
  ...partWatching,
  ...sales,
};

export default reducers;
